import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AuthService } from '@services/auth.service';
import { FswService } from '@services/fsw.service';
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { element } from 'protractor';
import * as EXIF from 'exif-js';

@Component({
  selector: 'app-add-testing',
  templateUrl: './add-testing.component.html',
  styleUrls: ['./add-testing.component.scss']
})
export class AddTestingComponent implements OnInit {
  testingFileUploadData: { testId: any; createdBy: string; } | undefined;
  testingData: { testId: any; createdBy: string } | undefined;
  p: number = 1;
  itemsPerPage: number = 10;
  arr: any;
  docs: any = [];
  images: any = [];
  fileInfos: any = [];
  pNew: any = [];
  length: number = 0;
  private apiURL = environment.apiURL;
  sampleResult:any;
  sampleResultOther:any;

  @ViewChild('myInput')
  myInputVariable!: ElementRef;

  constructor(private router: Router, private fswService: FswService, private authService: AuthService, private spinnerService: NgxSpinnerService, private toastr: ToastrService) { }
  fileName!: File;
  products!: any[];
  selectedproductId!: Number;
  pId!: Number;
  pName!: any[];
  count: Number = 0;
  selectedProductName!: any;
  testingProductName!: any;
  fileUploadId: any;

  submitted: boolean = false;
  test_id: any;
  testingRecordData!: any[];
  param_test: any[];
  isFileUploaded: boolean = false;
  flag: boolean = false;

  sampleDescription: any;
  physicalExamination: any;
  chemicalAnalysis: any;
  consumerName: any;
  fboName: any;
  district: any;
  labelDeclaraton: any;
  adulterated: any;
  otherObservations: any;

  ngOnInit(): void {
    this.bindProduct();
  }

  data!: [];
  parameters!: any[];
  addParameters: any[] = [];
  param: any = { name: "", value: "", result: "" };
  success: boolean = false;
  nonresult: boolean = false;
  fileFlag: boolean = false;
  name: any;
  value: any;
  recommendedValue: any;
  parameterName: any;
  result: any;
  isTested: any;

  bindProduct() {
    this.spinnerService.show();
    this.fswService.getProducts().subscribe((data: any[]) => {
      this.products = data;
      this.spinnerService.hide();
    })

  }
  productChanged() {
    if (this.selectedproductId != null) {
      let productObj = this.products.filter((x: any) => x.productId == this.selectedproductId)[0];
      this.selectedProductName = productObj.productName
      this.bindParameter(this.selectedproductId);
    }

  }

  bindParameter(productId: Number) {
    this.spinnerService.show();
    this.fswService.getProductVsParameters(productId).subscribe((data: any[]) => {
      if (data.length > 0) {
        /* this.parameters = data; */
        this.parameters = [];
        data.forEach((x: any) => {
          this.parameters.push(Object.assign(x, { "selectedParameter": false }));
        })

      }
      if (data.length == 0) {

        this.pNew.forEach((element: any) => {
          console.log(element.productId, element.productName)

          if (this.selectedproductId = element.productId) {
            //this.selectedProductName = element.productName;
          }
          // this.pName.push(element.productName)
        })


        console.log(this.pNew)
        this.toastr.error("No parameters found");
        this.parameters = [];
      }

      this.spinnerService.hide();
    })

  }

  public res: { [key: string]: any };

  updateInsertData() {
    debugger;

    if (this.testingProductName == null || this.testingProductName == '') {
      this.toastr.error('Please Insert Product Name');
      return;
    }

    if (this.consumerName == null || this.consumerName == '') {
      this.toastr.error('Please Insert Consumer Name');
      return;
    }

    if (this.fboName == null || this.fboName == '') {
      this.toastr.error('Please Insert FBO Name');
      return;
    }

    if (this.sampleDescription == null || this.sampleDescription == '')  {
      this.toastr.error('Please Insert Sample Description');
      return;
    }

    if (this.district == null || this.district == '') {
      this.toastr.error('Please Insert District/Area');
      return;
    }

    if (this.physicalExamination == null || this.physicalExamination == '') {
      this.toastr.error('Please Insert Physical Examination/Sensory Evaluation Test');
      return;
    }

    if (this.labelDeclaraton == null || this.labelDeclaraton == '') {
      this.toastr.error('Please Insert Label Declaration');
      return;
    }

    if (this.chemicalAnalysis == null || this.chemicalAnalysis == '') {
      this.toastr.error('Please Insert Chemical Analysis');
      return;
    }

    if (this.adulterated == null || this.adulterated == '') {
      this.toastr.error('Please Insert Adulterated/Misbranded/Within norms/Violates provision of');
      return;
    }

    if (this.otherObservations == null || this.otherObservations == '') {
      this.toastr.error('Please Insert Any Other Observations');
      return;
    }

    if (this.parameters.length > 0) {
      let checkFilterd = this.parameters.some((x: any) => x.selectedParameter == true);
      if (!checkFilterd) {
        this.toastr.error('Please Select Atleast One Parameter');
        return;
      }

      let checkParameterValue: boolean = true;
      let checkParameterRecommendValue: boolean = true;
      let checkParameterResult: boolean = true;
      this.parameters.forEach((x: any) => {
        if (x.selectedParameter == true) {
          if (x.value == null || x.value == '') {
            checkParameterValue = false;
          }

          if (x.recommendedValue == null || x.recommendedValue == '') {
            checkParameterRecommendValue = false;
          }

          if (x.result == null || x.result == '') {
            checkParameterResult = false;
          }
        }
      });

      if (!checkParameterValue) {
        this.toastr.error('Please enter the parameter value.');
        return;
      }

      
      if (!checkParameterRecommendValue) {
        this.toastr.error('Please enter the parameter recommend value.');
        return;
      }

      if (!checkParameterResult) {
        this.toastr.error('Please select the parameter result.');
        return;
      }
    }

    console.log(this.parameters)
    var sampleId = 0;
    var userName = this.authService.getUserName();
    let testingData: any = [];

    let getSampleId = {
      productId: this.selectedproductId,
      createdBy: this.authService.getUserName(),
      sampleDescription: this.sampleDescription,
      physicalExamination: this.physicalExamination,
      chemicalAnalysis: this.chemicalAnalysis,
      consumerName: this.consumerName,
      fboName: this.fboName,
      district: this.district,
      labelDeclaraton: this.labelDeclaraton,
      adulterated: this.adulterated,
      otherObservations: this.otherObservations,
      isTested:this.isTested,
      sampleResult:this.sampleResult,
      // sampleResultOther:this.sampleResultOther
    };
    this.fswService.generateSampleId(getSampleId).subscribe(resp => {
      sampleId = resp.sampleId;
      this.nonresult = false;

      if (this.nonresult) {
        this.toastr.error('Please Insert All Value and Select All Result!!');
        return;
      }

      if (this.parameters.length > 0) {

        if (this.parameters.length > 0) {
          this.flag = false;
          this.parameters.forEach(item => {
            if ((item.isTested && (item.value == null || item.recommendedValue == null || item.result == null)) || (item.isTested && (item.value == "" || item.recommendedValue == ""  || item.result == ""))) {
              this.flag = true;
            }
            if (this.flag) {
              this.toastr.error('Please Fill All Details');
              this.parameters.values = null;
              return;
            }
          });
          if (this.flag) {
            return;
          }
        }

        this.parameters.forEach(item => {
          if (item.selectedParameter && item.value != null && item.recommendedValue !=null  && item.result != null) {
            testingData.push({
              mappingId: item.id, productId: item.productId, parameterId: item.parameterId,
              value: item.value, recommendedValue: item.recommendedValue, result: item.result, selectedParameter: item.selectedParameter,
              createdBy: userName, sampleId: sampleId,
              activeFlag: 'Y', testingProductName: this.testingProductName,
              isTested:this.isTested, sampleResult:this.sampleResult,
            })

          }
          else {
            testingData.push({
              mappingId: item.id, productId: item.productId, parameterId: item.parameterId,
              value: "NA", recommendedValue: "NA", result: "NA", selectedParameter: "Not Tested",
              createdBy: userName, sampleId: sampleId,
              activeFlag: 'Y', testingProductName: this.testingProductName,
              isTested:this.isTested, sampleResult:this.sampleResult,
            })
          }

        });
        this.fswService.saveTestingData(testingData).subscribe(resp => {
          this.parameters = resp.testingData;
          console.log("a")
          console.log(resp)
          console.log("b")
          console.log(this.testingProductName)
          this.testingProductName = resp.testingProductName;
          this.test_id = sampleId;
        });
        console.log(this.length)
        console.log(this.parameters.length)
        if (this.addParameters.length > 0) {
          this.addParameters.forEach(item => { item.testId = sampleId, item.createdBy = userName, item.sampleResultOther = this.sampleResultOther })
          this.fswService.saveTestingDetails_Other(this.addParameters).subscribe(resp => {
          })
        }
        this.toastr.success('Testing Added Successfully!');
        this.router.navigate(['list-testing']);
        return;
      }

      else {
        if (this.parameters.length == 0) {
          if (this.addParameters.length == 0) {
            this.toastr.error('Please fill all details');
          }
          else {
            this.addParameters.forEach(item => {
              item.testId = sampleId,
                item.createdBy = userName,
                item.sampleResultOther = this.sampleResultOther
            })
            console.warn(this.addParameters)
            this.fswService.saveTestingDetails_Other(this.addParameters).subscribe(resp => {
            })
            this.toastr.success('Testing Added Successfully!');
            this.router.navigate(['list-testing']);
          }
        }
      }
    });
  }

  addMoreParameter() {
    console.log(this.parameterName)
    console.log(this.value)
    console.log(this.result)
    // debugger
    if (this.parameterName != null && this.value != null && this.result != null && this.recommendedValue != null) {
      this.addParameters.push({
        "parameterName": this.parameterName,
        "value": this.value,
        "recommendedValue": this.recommendedValue,
        "result": this.result,
        "isTested": "Yes",
        "testingProductName": this.testingProductName,
        // "sampleResultOther" : this.sampleResultOther
      });
      this.parameterName = null;
      this.value = null;
      this.recommendedValue = null;
      this.result = null;
      this.isTested = null;
      // this.sampleResultOther = null;
    }
    else if (this.parameterName != null && this.value == null && this.recommendedValue == null && this.result == null) {
      this.addParameters.push({
        "parameterName": this.parameterName,
        "value": "Not Tested",
        "recommendedValue": "Not Tested",
        "result": "NA",
        "isTested": this.isTested,
        "testingProductName": this.testingProductName,
        // "sampleResultOther" : this.sampleResultOther
      });
      this.parameterName = null;
      this.value = null;
      this.recommendedValue = null;
      this.result = null;
      this.isTested = null;
      // this.sampleResultOther = null;
    }
    else if (this.parameterName == null && this.value == null && this.result == null && this.recommendedValue == null) {
      this.toastr.error('Please Insert Parameter Name');
    }
    else {
      this.toastr.error('Please Insert All Values!');
    }
    
    let check=true;
    this.addParameters.forEach((ele:any)=>{
      if(ele.result=='Fail'){
        this.sampleResultOther='Fail';
        check=false;
      }
    });
    if(check){
      this.sampleResultOther='Pass';
    }
    else{
      this.sampleResultOther='Fail';
    }

    console.log(this.addParameters.length)
    this.addParameters.forEach((ele:any)=>{
      console.log("-----"+ele)
    })

  }

  resetPage() {
    this.fileName = null;
    this.products = [];
    this.testingProductName = null;
    this.selectedproductId = null;
    this.selectedProductName = null;
    this.submitted = false;
    this.test_id = null;
    this.testingRecordData = null;
    this.param_test = null;
    this.data = null;
    this.parameters = [];
    this.addParameters = [];
    this.param = null;
    this.success = false;
    this.nonresult = false;
    this.fileFlag = false;
    this.name = null;
    this.value = null;
    this.result = null;
    this.bindProduct();

  }

  check($event: any, index) {
    if (!$event.target.checked) {
      this.parameters[index].value = null;
      this.parameters[index].result = null;
    }
  }

  handleChange(evt:any) {
    console.log(this.parameters)
    let check=true;
    this.parameters.forEach((ele:any)=>{
      if(ele.result=='Fail'){
        this.sampleResult='Fail';
        check=false;
      }
    });
    if(check){
      this.sampleResult='Pass';
    }
    else{
      this.sampleResult='Fail';
    }
  }

  addMoreParam(event:any){
    console.log(this.parameters)
    let check=true;
    // this.parameters.forEach((ele:any)=>{
    //   if(ele.result=='Fail'){
    //     this.sampleResultOther='Fail';
    //     check=false;
    //   }
    // });
    // if(check){
    //   this.sampleResultOther='Pass';
    // }
    // else{
    //   this.sampleResultOther='Fail';
    // }
  }

}
